import { For, Show, createMemo } from "solid-js";
import type { Component } from "solid-js";
import { useLocationListQuery } from "../service";
import { useShellStore } from "@ui/state/shell";

const resolve = <T,>(input: T | (() => T)): T => (typeof input === "function" ? (input as () => T)() : input);

export const LocationListView: Component = () => {
  const query = useLocationListQuery();
  const {
    state,
    actions: { selectLocation },
  } = useShellStore();

  const locations = createMemo(() => resolve(query.data) ?? []);
  const isLoading = () => resolve(query.isLoading);
  const isFetching = () => resolve(query.isFetching);

  return (
    <section class="chat-list-view">
      <header class="chat-list-header">
        <div>
          <h1 class="main-placeholder-title">Service locations</h1>
          <p>Manage buildings, service status, and apartment coverage.</p>
        </div>
        <div class="chat-list-actions">
          <button
            type="button"
            class="button-primary refresh-button"
            onClick={() => void query.refetch()}
            disabled={isFetching()}
            title="Refresh"
          >
            <i class={`fa-solid fa-rotate-right ${isFetching() ? "spinning" : ""}`}></i>
          </button>
        </div>
      </header>

      <Show when={!isLoading()} fallback={<div class="placeholder-card">Loading locations...</div>}>
        <Show when={locations().length > 0} fallback={<div class="placeholder-card">No locations onboarded yet.</div>}>
          <table class="chat-table">
            <thead>
              <tr>
                <th>Location</th>
                <th class="mobile-hide">Status</th>
                <th class="mobile-hide">City</th>
                <th>Floors</th>
                <th>Apartments</th>
              </tr>
            </thead>
            <tbody>
              <For each={locations()}>
                {(location) => (
                  <tr
                    class={state.selectedLocationId === location.id ? "is-selected" : ""}
                    onClick={() => selectLocation(location.id)}
                  >
                    <td class="chat-user">{location.name}</td>
                    <td class="mobile-hide">
                      <span class={`booking-status booking-status--${location.serviceStatus ?? "unknown"}`}>
                        {location.serviceStatus ?? "unknown"}
                      </span>
                    </td>
                    <td class="chat-preview mobile-hide">
                      {location.city ? `${location.city}${location.state ? ", " + location.state : ""}` : "-"}
                    </td>
                    <td>{location.totalFloors}</td>
                    <td>{location.totalApartments}</td>
                  </tr>
                )}
              </For>
            </tbody>
          </table>
        </Show>
      </Show>
    </section>
  );
};
